<!-- <p>asset-search-dialog works!</p> -->
<app-dialog-header headerText="Find Asset" (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="search-dialog-container">
    <div class="middle-div alignRow">
        <span class="toolbar-spacer"></span>
        <mat-icon style="cursor: pointer;" *ngIf="selectedLocation"
            (click)="filterByLocation($event, true)">close</mat-icon>
        <div class="location-dropdown">
            <ejs-dropdownlist id="dropdown" #locationDropdown [dataSource]='MainLocations' placeholder="Select Location"
                [fields]="locationFields" (change)="filterByLocation($event)" [allowFiltering]="true"
                filterType="contains">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{ data.Name }}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
        </div>
    </div>
    <mat-form-field>
        <mat-label>Search for an Asset</mat-label>
        <input matInput (keyup)="onFiltering($event)" placeholder="" #input cdkFocusInitial>
    </mat-form-field>
    <form [formGroup]="dialogForm" autocomplete="off">
        <ejs-dropdownlist #dropdown [dataSource]='filteredAssetList' [enablePersistence]="true" placeholder="Asset"
            [fields]="fields" formControlName="asset" (change)="selectAsset($event)" [popupWidth]="'120%'">
            <ng-template #itemTemplate let-data>
                <div>
                    <span>{{ data.Name }} - {{ data.Description}}</span>
                </div>
            </ng-template>
        </ejs-dropdownlist>
        <div class="asset-details-container alignRow">
            <div *ngIf="selectedAsset" class="image-div">
                <img (click)="viewImage(imagePathAssets() + selectedAsset.AssetID + '?' + selectedAsset.Modified)"
                    style="max-height: 100px; max-width: 100px;"
                    src="{{imagePathAssets()}}{{selectedAsset.AssetID}}?{{selectedAsset.Modified}}"
                    alt="{{selectedAsset.Name}}"
                    onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
            </div>
            <div *ngIf="selectedAsset" class="asset-details">
                <span><b>Name:</b></span>
                <span>{{selectedAsset.Name}}</span>
                <span><b>Description:</b></span>
                <span>{{selectedAsset.Description}}</span>
                @if (selectedAsset.FunctionalLocation != '') {
                <span><b>Functional Location:</b></span>
                <span>{{selectedAsset.FunctionalLocation}}</span>
                } @else if (selectedAsset.ParentFunctionalLocation != '') {
                <span><b>Functional Location:</b></span>
                <span>{{selectedAsset.ParentFunctionalLocation}}</span>
                }

            </div>
            <div *ngIf="!selectedAsset" style="text-align: center;"><b>Select an Asset from the dropdown menu.</b>
                <br>Filter Assets by Location using the top dropdown or search for a specific Asset using the text box.
            </div>
        </div>
        <div class="asset-path" *ngIf="selectedAsset && assetPath">
            <span *ngFor="let part of assetPath" class="alignRow" style="cursor: pointer;"
                (click)="goToFunctionalLocation(part)">
                {{part.Name}}
                <mat-icon>chevron_right</mat-icon>
            </span>
            <span class="alignRow" style="font-weight: bolder; text-decoration: none !important;">
                {{selectedAsset.Name}} - {{selectedAsset.Description}}
            </span>
        </div>
        <div mat-dialog-actions>
            <button mat-button [mat-dialog-close]="dialogForm.value"
                [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
            <button mat-button (click)="onCancelClick()">Cancel</button>
        </div>
    </form>
</div>